/** @jsx builderX.jsx */

import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='resourcesToLoad'>
        <Image src='close_button_normal' />
        <Image src='radiobutton_off_disabled' />
        <Image src='radiobutton_off_focused' />
        <Image src='radiobutton_off_normal' />
        <Image src='radiobutton_off_pressed' />
        <Image src='radiobutton_on_green_disabled' />
        <Image src='radiobutton_on_green_focused' />
        <Image src='radiobutton_on_green_normal' />
        <Image src='radiobutton_on_green_pressed' />
        <Image src='balance_desktop' />
        <Image src='totalbet_desktop' />
        <Image src='win_desktop' />
        <Image src='balance_mobile' />
        <Image src='totalbet_mobile' />
        <Image src='win_mobile' />
        <Image src='popup_header_bg' />
        <Image src='see_more_icon' />
        <Image src='auto_icon' />
        <Image src='stop_autoplay_normal_en' />
        <Image src='turbo_icon_off_normal_en' />
        <Image src='close_button_pressed' />
    </Sprite>
);
